import SEOTags from "@/components/SEOTags";
import Footer from "@/pagecomponents/newcomponents/Footer";
import Navbar from "@/pagecomponents/newcomponents/Navbar";
import {
  ArrowRight,
  BookOpen,
  LifeBuoy,
  Mail,
  MessageCircle,
  ShieldCheck,
} from "lucide-react";

import styles from "./style.module.css";

const contactOptions = [
  {
    label: "Account & product",
    title: "Product and account support",
    description:
      "Get help with your account, subscription, application preferences, or LifeShack product experience.",
    email: "support@lifeshack.com",
    icon: LifeBuoy,
  },
  {
    label: "Data & privacy",
    title: "Privacy requests",
    description:
      "Ask about access, correction, deletion, or another privacy-related request.",
    email: "privacy@lifeshack.com",
    icon: ShieldCheck,
  },
  {
    label: "Company & partnerships",
    title: "General questions",
    description:
      "Contact the LifeShack team about partnerships, company information, or another general inquiry.",
    email: "hello@lifeshack.com",
    icon: MessageCircle,
  },
];

export default function ContactPage() {
  return (
    <>
      <SEOTags
        title="Contact LifeShack"
        description="Contact LifeShack for product support, account questions, privacy requests, partnerships, or general company inquiries."
        url="https://www.lifeshack.com/contact/"
      />
      <Navbar secondary />
      <main className={styles.page}>
        <div className={styles.container}>
          <header className={styles.hero}>
            <p className={styles.eyebrow}>
              Contact LifeShack
            </p>
            <h1>How can we help?</h1>
            <p className={styles.intro}>
              Choose the team that best matches your question. Include the email
              associated with your account and a short description so we can
              route your message quickly.
            </p>
            <div className={styles.safetyNote}>
              <ShieldCheck aria-hidden="true" size={18} />
              <span>
                Never email passwords, payment card details, or job-board
                credentials.
              </span>
            </div>
          </header>

          <div className={styles.optionsGrid}>
            {contactOptions.map((option) => {
              const Icon = option.icon;

              return (
              <section
                key={option.email}
                className={styles.contactCard}
              >
                <div className={styles.iconWrap}>
                  <Icon aria-hidden="true" size={22} />
                </div>
                <p className={styles.cardLabel}>{option.label}</p>
                <h2>{option.title}</h2>
                <p className={styles.cardDescription}>
                  {option.description}
                </p>
                <a
                  className={styles.emailLink}
                  href={`mailto:${option.email}`}
                  aria-label={`Email ${option.title} at ${option.email}`}
                >
                  <Mail aria-hidden="true" size={17} />
                  <span>{option.email}</span>
                  <ArrowRight aria-hidden="true" size={17} />
                </a>
              </section>
              );
            })}
          </div>

          <section className={styles.helpBanner}>
            <div className={styles.helpIcon}>
              <BookOpen aria-hidden="true" size={24} />
            </div>
            <div className={styles.helpCopy}>
              <h2>Need a quick product answer?</h2>
              <p>
                Find guidance on getting started, account controls,
                subscriptions, application preferences, and Auto Apply.
              </p>
            </div>
            <a
              className={styles.helpLink}
              href="/help/"
            >
              Help Center
              <ArrowRight aria-hidden="true" size={18} />
            </a>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
